module.exports = __webpack_public_path__ + "static/media/alibaba_login_background.bf8d11f5.png";